import { forwardRef } from 'react';

export const UserIconLarge = forwardRef<SVGSVGElement>(() => {
  return (
    <svg width="114" height="114" viewBox="0 0 114 114" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9429 69.86V48.1362C15.9429 40.8281 19.8296 34.0719 26.1433 30.395L46.6718 18.4474C53.0539 14.734 60.9415 14.734 67.3236 18.4474L87.8521 30.395C94.1703 34.0719 98.0571 40.8281 98.0571 48.1362V69.86C98.0571 77.1682 94.1703 83.9243 87.8567 87.6012L67.3281 99.5488C60.946 103.262 53.0585 103.262 46.6764 99.5488L26.1478 87.6012C19.8296 83.9243 15.9429 77.1682 15.9429 69.86Z"
        fill="#B4EB56"
      />
      <path
        d="M56.9998 40.7505C62.5973 40.7505 67.1364 45.2896 67.1364 50.887C67.1364 56.4845 62.5973 61.0236 56.9998 61.0236C51.4024 61.0236 46.8633 56.4845 46.8633 50.887C46.8633 45.2896 51.4024 40.7505 56.9998 40.7505"
        stroke="#4B484D"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#B4EB56"
      />
      <path
        d="M75.2474 77.2458C74.7182 75.9092 73.8925 74.714 72.8387 73.7377V73.7377C71.055 72.0863 68.7284 71.1648 66.2969 71.1648C62.2414 71.1648 51.7627 71.1648 47.7072 71.1648C45.2757 71.1648 42.9446 72.0863 41.1609 73.7377V73.7377C40.1071 74.7094 39.2859 75.9092 38.7522 77.2458"
        stroke="#4B484D"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#B4EB56"
      />
    </svg>
  );
});
